import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import * as FilterHelpers from '../../helpers/changelog/filter'
import Button from '../Button'
import ButtonOutline from '../Button/ButtonOutline'
import ChangelogFilterGroup from './ChangelogFilterGroup'
import styles from './styles.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function ChangelogFilter({ filter, onSelectFilter, onClearFilter }) {
  const [isFiltered, setIsFiltered] = useState(false)
  const [countFiltered, setCountFiltered] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const filterOpenStyles = isOpen ? styles.filterIsOpen : ''

  const { t } = useTranslation()
  const { title, date, solution, changeType, button } = useMemo(
    () => ({
      title: t('changelog.filter.title'),
      date: {
        title: t('changelog.filter.date.title'),
        groupName: 'months',
      },
      solution: {
        title: t('changelog.filter.solution.title'),
        groupName: 'apps',
      },
      changeType: {
        title: t('changelog.filter.changeType.title'),
        groupName: 'changeTypes',
      },
      button: {
        open: t('changelog.filter.openFilterCTA'),
        apply: t('changelog.filter.applyFilterCTA'),
        clear: t('changelog.filter.clearFilterCTA'),
      },
    }),
    [t]
  )

  useEffect(() => {
    const filterGroup = FilterHelpers.getFiltersSelected(filter)
    const countFilterSelected = FilterHelpers.getCountFilterSelected(filterGroup)
    const hasFilterSelected = countFilterSelected > 0

    setCountFiltered(countFilterSelected)
    setIsFiltered(hasFilterSelected)
  }, [filter])

  return (
    <>
      <div
        className={`${styles.changelogBackdropFilter} ${filterOpenStyles}`}
        onClick={() => setIsOpen(false)}
        onKeyUp={() => setIsOpen(false)}
        aria-hidden={!isOpen}
        role="presentation"
      ></div>

      <div className={styles.changelogFilterCtrlMobile} data-testid="changelog-filter-ctrl">
        <Button onClick={() => setIsOpen(true)} data-testid="changelog-show-filter">
          <FontAwesomeIcon data-testid="filter-icon" icon={['far', 'filter']} />
          {button.open}
        </Button>

        {isFiltered && (
          <ButtonOutline onClick={onClearFilter} data-testid="changelog-clear-filter-mobile">
            {button.clear} ({countFiltered})
          </ButtonOutline>
        )}
      </div>

      <aside className={`${styles.changelogFilter} ${filterOpenStyles}`}>
        <div className={styles.changelogFilterHeader}>
          <div className={styles.changelogFilterTitle}>
            <FontAwesomeIcon data-testid="filter-icon" icon={['far', 'filter']} />
            <span>{title}</span>
          </div>

          <button className={styles.changelogCloseButton} onClick={() => setIsOpen(false)}>
            <FontAwesomeIcon data-testid="close-icon" icon={['far', 'times']} />
          </button>
        </div>

        <div className={styles.changelogFilterContent}>
          <ChangelogFilterGroup title={date.title} filterGroupName={date.groupName} filter={filter} onSelect={onSelectFilter} />
          <ChangelogFilterGroup title={solution.title} filterGroupName={solution.groupName} filter={filter} onSelect={onSelectFilter} />
          <ChangelogFilterGroup title={changeType.title} filterGroupName={changeType.groupName} filter={filter} onSelect={onSelectFilter} />
        </div>

        <div className={styles.changelogFilterFooter} data-testid="changelog-filter-footer">
          {isFiltered && (
            <ButtonOutline onClick={onClearFilter} data-testid="changelog-clear-filter">
              {button.clear}
            </ButtonOutline>
          )}

          {isOpen && (
            <Button className={styles.changelogFilterApplyButton} onClick={() => setIsOpen(false)} data-testid="changelog-apply-filter">
              {button.apply}
            </Button>
          )}
        </div>
      </aside>
    </>
  )
}

export default ChangelogFilter
